import React from 'react';
import { useInactivityTimer } from '../hooks/useInactivityTimer';
import InactivityWarningModal from './inactivity-warning-modal';

interface InactivityManagerProps {
  isEnabled: boolean;
}

const InactivityManager: React.FC<InactivityManagerProps> = ({ isEnabled }) => {
  const {
    showWarningModal,
    remainingTime,
    stayLoggedIn,
    logoutNow,
  } = useInactivityTimer(isEnabled);

  return (
    <InactivityWarningModal
      isOpen={showWarningModal}
      remainingTime={remainingTime}
      onStayLoggedIn={stayLoggedIn}
      onLogoutNow={logoutNow}
    />
  );
};

export default InactivityManager;